import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CrmDrawer({ selectedCustomer, setSelectedCustomer }) {
  const navigate = useNavigate();

  if (!selectedCustomer) return null;

  const handleOpenFullEdit = () => {
    const id = selectedCustomer.customerID || selectedCustomer.id;
    setSelectedCustomer(null);
    navigate(`/crm/edit/${id}`);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Kupac': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
      case 'VIP': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
      case 'Odustao':
      case 'Raskid': return 'bg-rose-50 text-rose-700 border-rose-200';
      default: return 'bg-amber-50 text-amber-700 border-amber-200';
    }
  };

  return (
    <>
      {/* Zatamnjena pozadina */}
      <div 
        className="fixed inset-0 bg-slate-900/60 backdrop-blur-xs z-[60] transition-opacity cursor-pointer" 
        onClick={() => setSelectedCustomer(null)}
      ></div>

      {/* Bočni panel */}
      <div className="fixed top-0 right-0 h-full w-full sm:w-[420px] bg-white z-[70] shadow-2xl flex flex-col border-l border-slate-200 animate-in slide-in-from-right duration-200">
        
        {/* Zaglavlje ladice */}
        <div className="p-5 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
          <div>
            <h2 className="text-base font-bold text-slate-900">{selectedCustomer.fullName || selectedCustomer.fullname}</h2>
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
              Kupac #{selectedCustomer.customerID || selectedCustomer.id}
            </p>
          </div>
          <button 
            type="button"
            className="w-8 h-8 flex items-center justify-center rounded-xl text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition cursor-pointer font-bold text-sm" 
            onClick={() => setSelectedCustomer(null)}
          >
            ✕
          </button>
        </div>

        {/* Sadržaj stvarnih podataka iz baze */}
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          
          {/* Status klijenta */}
          <div>
            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1.5">Status klijenta</span>
            <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-lg border ${getStatusBadgeClass(selectedCustomer.status)}`}>
              {selectedCustomer.status || 'Zainteresiran'}
            </span>
          </div>

          {/* Telefon i IBAN */}
          <div className="grid grid-cols-2 gap-3">
            <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-xl space-y-1">
              <p className="text-[10px] text-slate-400 uppercase font-bold">Broj mobitela</p>
              <p className="text-xs font-bold text-slate-800 break-all">{selectedCustomer.phoneNumber || selectedCustomer.phonenumber || '—'}</p>
            </div>
            <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-xl space-y-1">
              <p className="text-[10px] text-slate-400 uppercase font-bold">IBAN Računa</p>
              <p className="text-xs font-bold text-slate-800 break-all">{selectedCustomer.iban || '—'}</p>
            </div>
          </div>

          {/* Opći komentar */}
          <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-xl space-y-1">
            <p className="text-[10px] text-slate-400 uppercase font-bold">Komentar / Bilješke</p>
            <p className="text-xs text-slate-700 font-medium whitespace-pre-wrap leading-relaxed">
              {selectedCustomer.comment || 'Nema upisanog komentara.'}
            </p>
          </div>
        </div>

        {/* Gumb za prelazak na puno uređivanje */}
        <div className="p-4 border-t border-slate-100 bg-white">
          <button
            type="button"
            onClick={handleOpenFullEdit}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs py-3 rounded-xl transition shadow-xs cursor-pointer flex items-center justify-center gap-2"
          >
            <span>Uredi kupca, nekretnine i rate</span>
            <span>→</span>
          </button>
        </div>

      </div>
    </>
  );
}